interface Props {
  time?: string;
  day?: string;
  date?: string;
  hi?: string;
}

export function TabletDevice({
  time = '09:42',
  day = 'mardi',
  date = '21 mai',
  hi = 'soleil dehors.',
}: Props) {
  const [h, m] = time.split(':');
  return (
    <div className="device-pi">
      <div className="screen">
        <div className="cadran-home">
          <div className="top">
            <div className="clock">
              <span>{h}</span>
              <span className="colon">:</span>
              <span>{m}</span>
            </div>
            <div className="greet">
              <div className="day">{day}</div>
              <div className="date">{date}</div>
              <div className="hi">{hi}</div>
            </div>
          </div>
          <div className="agenda">
            <div className="label">aujourd'hui —</div>
            <div className="ev">
              <div className="h">10:30</div>
              <div className="body">
                <div className="t">Kiné, Dr Albert</div>
                <div className="l">3 rue de l'Église</div>
              </div>
            </div>
            <div className="ev">
              <div className="h">15:00</div>
              <div className="body">
                <div className="t">Anniversaire de Léa</div>
                <div className="l">elle a 8 ans</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
